/* ==========================================================================
   LEON - Geschenke-Leiste (Qikify Booster Kit neu gestaltet)
   Gehoert zu: snippets/leon-geschenke-leiste.liquid

   WARUM WIR SELBST RECHNEN
   Erster Ansatz war, den Zustand aus der gerenderten App-Leiste zu spiegeln.
   Live gemessen: die App aktualisiert ihre Leiste NICHT, wenn sich der
   Warenkorb aendert - null DOM-Mutationen beim Einloesen, kein Reload. Sie
   rechnet nur beim Seitenaufbau. Gespiegelt haetten wir genau diese Schwaeche
   geerbt. Deshalb: Schwellen aus window._BK, Warenkorb aus /cart.js, Bestand
   aus /products/<handle>.js - und wir zeichnen bei jeder Warenkorb-Aenderung
   neu. Das Einloesen selbst bleibt beim automatischen Shopify-Rabatt.

   DER VERTRAG MIT DER APP (live beobachtet, nicht geraten)
   Ein eingeloestes Geschenk ist eine Warenkorb-Position mit
       properties['_qbk-tier'] = "<min_subtotal der Stufe>"
   und final_price 0. Dazu traegt der Warenkorb das Attribut
       _qbk-offer-id = "<Kampagnen-ID>"
   Der 100-%-Rabatt ist ein automatischer Shopify-Rabatt und wird
   serverseitig geprueft. Deshalb pruefen wir nach jedem Schreibvorgang
   nach, ob die Position wirklich 0 EUR kostet - siehe pruefeUndSichere().

   FALLBACK
   Unser Container startet versteckt, die App-Leiste ist sichtbar. Erst wenn
   unsere Leiste nachweislich Inhalt und Hoehe hat, wird die App-Leiste
   optisch ausgeblendet - nie entfernt, denn ihre Meilenstein-Buttons oeffnen
   weiterhin das Geschenk-Popup. Jeder Fehler stellt sie wieder her.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__leonGeschenkeLeiste) return;
  window.__leonGeschenkeLeiste = true;

  // Versionsnummer im Schluessel: aendert sich das gespeicherte Format,
  // werden alte Eintraege automatisch ignoriert statt falsch gelesen.
  var CACHE = 'lgl-produkt-v3-';
  var instanzen = [];

  var HAKEN = '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="5 12.4 9.6 17 19 7.4"/></svg>';
  var SCHLOSS = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>';
  var PLUS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  var GESCHENK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 21V7M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 1 0 0-5C13 2 12 7 12 7z"/></svg>';

  function escape(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var WURZEL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function pfad(p) { return WURZEL.replace(/\/$/, '') + p; }

  var KURS = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
  function geldKurz(cent) {
    try {
      var w = (window.Shopify && Shopify.currency && Shopify.currency.active) || (window.qbkStore && window.qbkStore.currency) || 'EUR';
      var l = ((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'de').split('-')[0] + ((window.Shopify && Shopify.country) ? '-' + Shopify.country : '');
      return new Intl.NumberFormat(l, { style: 'currency', currency: w, maximumFractionDigits: 0 }).format(cent / 100);
    } catch (e) {
      return Math.round(cent / 100) + ' \u20AC';
    }
  }

  function geld(cent) {
    try {
      var w = (window.Shopify && Shopify.currency && Shopify.currency.active) || (window.qbkStore && window.qbkStore.currency) || 'EUR';
      var l = ((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'de').split('-')[0] + ((window.Shopify && Shopify.country) ? '-' + Shopify.country : '');
      return new Intl.NumberFormat(l, { style: 'currency', currency: w }).format(cent / 100);
    } catch (e) {
      return (cent / 100).toFixed(2);
    }
  }

  /* ---------------------------------------------------------------- Kampagne */
  function kampagne() {
    try {
      var bk = window._BK;
      if (!bk || !Array.isArray(bk.entries)) return null;
      for (var i = 0; i < bk.entries.length; i++) {
        var e = bk.entries[i];
        if (e && e.type === 'gift-goal' && Array.isArray(e.tiers_percentage) && e.tiers_percentage.length) return e;
      }
    } catch (e) { /* faellt durch */ }
    return null;
  }

  // "amount" = nur der Warenkorbwert zaehlt, "quantity" = nur die Stueckzahl.
  // Das Feld entscheidet, welches der beiden Tier-Felder ueberhaupt gilt.
  function bedingungsTyp(k) {
    return k && k.minimum_purchase_type === 'quantity' ? 'quantity' : 'amount';
  }

  function stufen(k) {
    return k.tiers_percentage.map(function (t) {
      return {
        /* TB V10.0: Schwelle steht in Shopwährung (EUR), der Warenkorb in Seitenwährung (z. B. CHF) → umrechnen wie die App selbst */
        schwelle: Math.round(parseFloat(t.min_subtotal || 0) * 100 * KURS),   // in Cent, Seitenwährung
        mindestmenge: parseInt(t.min_quantity, 10) || 0,
        schluessel: String(t.min_subtotal),                             // = Wert von _qbk-tier
        geschenke: (Array.isArray(t.offer_product_data) ? t.offer_product_data : []).map(function (p) {
          return {
            id: String(p.id),
            titel: p.title || '',
            handle: p.handle || '',
            bild: (p.image && p.image.url) ? String(p.image.url) : ''
          };
        }).filter(function (g) { return g.bild && g.handle; })
      };
    });
  }

  /* ------------------------------------------------------- Bestand je Produkt */
  var laufendeAbfragen = {};

  function bestand(handle) {
    try {
      var roh = sessionStorage.getItem(CACHE + handle);
      if (roh) {
        var d = JSON.parse(roh);
        if (d && 'preis' in d) return d;   // aelteres Format: neu holen
      }
    } catch (e) { /* Speicher kann blockiert sein */ }
    return null;
  }

  function holeBestand(handle, fertig) {
    if (laufendeAbfragen[handle]) return;
    laufendeAbfragen[handle] = true;
    fetch(pfad('/products/' + handle + '.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        var v = Array.isArray(p.variants) && p.variants[0] ? p.variants[0] : null;
        // Bild bewusst von hier und nicht aus _BK: die Kampagnendaten der App
        // veralten (live gesehen: eine hinterlegte Bild-URL lieferte 404).
        var daten = {
          verfuegbar: !!p.available,
          variante: v ? v.id : null,
          varianten: (p.variants || []).length,
          bild: p.featured_image || (p.images && p.images[0]) || '',
          titel: p.title || '',
          preis: v ? v.price : p.price,
          vergleich: v && v.compare_at_price ? v.compare_at_price : (p.compare_at_price || 0)
        };
        try { sessionStorage.setItem(CACHE + handle, JSON.stringify(daten)); } catch (e) { /* egal */ }
        fertig();
      })
      .catch(function () { /* ohne Bestand rendern wir eben ohne */ });
  }

  /* ---------------------------------------------------------------- Warenkorb */
  function ladeWarenkorb() {
    return fetch(pfad('/cart.js'), { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  // Geschenke zaehlen weder beim Betrag noch bei der Menge mit. Sonst koennte
  // ein Geschenk die naechste Stufe freischalten - das waere zirkulaer.
  function warenkorbZustand(cart) {
    var betrag = 0, menge = 0, eingeloest = {};
    (cart.items || []).forEach(function (i) {
      var stufe = i.properties && i.properties['_qbk-tier'];
      if (stufe) {
        eingeloest[String(stufe)] = { produkt: String(i.product_id), schluesselZeile: i.key, preis: i.final_price };
        return;
      }
      betrag += i.final_line_price != null ? i.final_line_price : (i.final_price * i.quantity);
      menge += i.quantity;
    });
    return { betrag: betrag, menge: menge, eingeloest: eingeloest };
  }

  /* ----------------------------------------------------------- Schreibzugriffe */
  function warenkorbAendern(koerper) {
    return fetch(pfad('/cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(koerper)
    }).then(function (r) { return r.json(); });
  }

  function warenkorbHinzufuegen(varianteId, stufenSchluessel) {
    var eigenschaften = {};
    eigenschaften['_qbk-tier'] = stufenSchluessel;
    return fetch(pfad('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: varianteId, quantity: 1, properties: eigenschaften }] })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, daten: d }; }); });
  }

  function setzeAttribut(wert) {
    return fetch(pfad('/cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { '_qbk-offer-id': String(wert) } })
    }).then(function (r) { return r.json(); });
  }

  function drawerAktualisieren(oeffnen) {
    try {
      if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
        // true = Drawer oeffnen: der Kunde soll sein Geschenk sofort im
        // Warenkorb sehen. Beim Abwaehlen waere das unnoetig, deshalb
        // steuert der Aufrufer das ueber den Parameter.
        window.ajaxCart.load(false, oeffnen !== false, false, true);
      }
    } catch (e) { /* egal */ }
  }

  /* ================================================================== Instanz */
  function bediene(box) {
    var quelle = box.nextElementSibling;
    if (!quelle || !quelle.hasAttribute('data-lgl-quelle')) {
      quelle = box.parentElement && box.parentElement.querySelector('[data-lgl-quelle]');
    }
    if (!quelle) return;

    var variante = box.getAttribute('data-lgl-variante') === 'b' ? 'b' : 'a';
    var texte = {
      waehlen: box.getAttribute('data-lgl-waehlen') || '',
      betrag: box.getAttribute('data-lgl-betrag') || '',
      artikelEins: box.getAttribute('data-lgl-artikel-eins') || '',
      artikelViele: box.getAttribute('data-lgl-artikel-viele') || '',
      fertig: box.getAttribute('data-lgl-fertig') || '',
      ausverkauft: box.getAttribute('data-lgl-ausverkauft') || '',
      kostenlos: box.getAttribute('data-lgl-kostenlos') || ''
    };

    var k = kampagne();
    var alleStufen = k ? stufen(k) : null;
    var typ = bedingungsTyp(k);
    // Variante B: welche Stufe ist gerade aufgeklappt? null = keine.
    var offeneStufe = null;
    var warenkorb = null;
    var beschaeftigt = false;

    // Bewusst KEIN Zurueckschalten auf die App-Leiste mehr: die ist bereits
    // serverseitig ausgeblendet, damit beim Nachrendern nichts springt (CLS).
    // Die Hoehe ist per min-height im CSS reserviert.
    function zurueck() {
      box.__markup = '';
      box.innerHTML = '';
    }

    /* --- Popup der App oeffnen (unveraenderte Rabattlogik) ------------------ */
    function popupOeffnen(stufenIndex) {
      if (window.__lglPopupErlauben) window.__lglPopupErlauben();
      var punkte = quelle.querySelectorAll('.qbk-order-goal__milestone');
      if (punkte[stufenIndex]) punkte[stufenIndex].click();
      else if (punkte[0]) punkte[0].click();
    }

    /* --- Sicherheitsnetz ---------------------------------------------------
       Nach jedem Hinzufuegen pruefen, ob die Position wirklich 0 EUR kostet.
       Wenn nicht, sofort wieder entfernen und stattdessen das Popup oeffnen -
       lieber ein Klick mehr als ein Kunde, der sein Geschenk bezahlt.        */
    function pruefeUndSichere(stufe, stufenIndex) {
      return ladeWarenkorb().then(function (cart) {
        var zeile = null;
        (cart.items || []).forEach(function (i) {
          if (i.properties && String(i.properties['_qbk-tier']) === stufe.schluessel) zeile = i;
        });
        if (!zeile) return { ok: false };
        if (zeile.final_price === 0) return { ok: true, cart: cart };
        return warenkorbAendern({ id: zeile.key, quantity: 0 }).then(function () {
          return { ok: false, rabattFehlt: true };
        });
      });
    }

    /* --- Geschenk waehlen, wechseln oder abwaehlen -------------------------- */
    function geschenkKlick(stufenIndex, geschenkId) {
      if (beschaeftigt || !alleStufen || !warenkorb) return;
      var stufe = alleStufen[stufenIndex];
      if (!stufe) return;

      var zustand = warenkorbZustand(warenkorb);
      if (!istFrei(stufe, zustand)) { popupOeffnen(stufenIndex); return; }

      var g = null;
      stufe.geschenke.forEach(function (x) { if (x.id === geschenkId) g = x; });
      if (!g) return;

      var b = bestand(g.handle);
      if (!b || !b.verfuegbar || !b.variante) { popupOeffnen(stufenIndex); return; }

      var bisher = zustand.eingeloest[stufe.schluessel] || null;
      var abwaehlen = bisher && bisher.produkt === g.id;

      beschaeftigt = true;
      box.classList.add('lgl--laedt');

      var kette = Promise.resolve();
      if (bisher) {
        kette = kette.then(function () { return warenkorbAendern({ id: bisher.schluesselZeile, quantity: 0 }); });
      }
      if (!abwaehlen) {
        kette = kette
          .then(function () { return k && k.id ? setzeAttribut(k.id) : null; })
          .then(function () { return warenkorbHinzufuegen(b.variante, stufe.schluessel); })
          .then(function (res) {
            if (!res.ok || (res.daten && res.daten.status)) throw new Error('add fehlgeschlagen');
            return pruefeUndSichere(stufe, stufenIndex);
          })
          .then(function (p) {
            if (!p.ok) popupOeffnen(stufenIndex);
          });
      }

      kette
        .catch(function () { popupOeffnen(stufenIndex); })
        .then(function () {
          beschaeftigt = false;
          box.classList.remove('lgl--laedt');
          drawerAktualisieren(!abwaehlen);
          planeAktualisierung();
        });
    }

    /* --- Zustandsfragen ----------------------------------------------------- */
    /* Nur EINE der beiden Bedingungen gilt, je nach minimum_purchase_type.
       Vorher wurden beide UND-verknuepft - dadurch blieb Stufe 1 gesperrt,
       weil dort min_quantity: 2 hinterlegt ist. Bei "amount" ignoriert die
       App dieses Feld aber vollstaendig: live gegengeprueft mit einem
       Artikel ueber 370 EUR - die App meldete Stufe 1 als erreicht, wir
       nicht. Das Feld ist in dieser Kampagne schlicht Altlast. */
    function istFrei(stufe, zustand) {
      if (typ === 'quantity') return zustand.menge >= stufe.mindestmenge;
      return zustand.betrag >= stufe.schwelle;
    }

    /* --- Markup ------------------------------------------------------------- */
    function baue(zustand) {
      var frei = alleStufen.map(function (s) { return istFrei(s, zustand); });
      var anzahlFrei = frei.filter(Boolean).length;
      var maxSchwelle = alleStufen[alleStufen.length - 1].schwelle || 1;

      // Welche Stufe zeigen wir? Erste freie ohne eingeloestes Geschenk,
      // sonst erste noch nicht freie, sonst die letzte.
      var zeigeIdx = -1;
      alleStufen.forEach(function (s, i) {
        if (zeigeIdx === -1 && frei[i] && !zustand.eingeloest[s.schluessel]) zeigeIdx = i;
      });
      if (zeigeIdx === -1) { for (var i = 0; i < alleStufen.length; i++) { if (!frei[i]) { zeigeIdx = i; break; } } }
      if (zeigeIdx === -1) zeigeIdx = alleStufen.length - 1;

      // Kopftext
      var text;
      if (anzahlFrei === alleStufen.length) {
        text = texte.fertig;
      } else {
        var naechste = alleStufen[frei.lastIndexOf(true) + 1] || alleStufen[0];
        for (var j = 0; j < alleStufen.length; j++) { if (!frei[j]) { naechste = alleStufen[j]; break; } }
        if (typ === 'quantity') {
          var fehlt = Math.max(1, naechste.mindestmenge - zustand.menge);
          text = fehlt === 1 ? texte.artikelEins : texte.artikelViele.replace('999999', fehlt);
        } else {
          text = texte.betrag.replace('__BETRAG__', geld(naechste.schwelle - zustand.betrag));
        }
      }

      var h = '';
      h += '<div class="lgl__kopf">';
      h += '<p class="lgl__text">' + escape(text) + '</p>';
      h += '<span class="lgl__zahl" aria-hidden="true">' + GESCHENK + anzahlFrei + '/' + alleStufen.length + '</span>';
      h += '</div>';

      /* ---------------------------------------------------------------
         Variante B (Cart Drawer): die Geschenkbilder SIND die Meilensteine.
         Spart gegenueber A eine ganze Kachelzeile - im Drawer konkurriert
         die Leiste mit dem Cross-Selling-Block um Hoehe.
         Ein Klick oeffnet hier immer das Popup und legt nicht direkt in den
         Warenkorb: die Kachel steht fuer die ganze Stufe, nicht fuer ein
         einzelnes Geschenk. Waehlt der Kunde eines aus, zeigt die Kachel
         dessen Bild mit gruenem Haken.
         --------------------------------------------------------------- */
      if (variante === 'b') {
        h += '<div class="lgl__track lgl__track--b">';
        h += '<span class="lgl__fill" style="width:' + Math.min(100, (zustand.betrag / maxSchwelle) * 100).toFixed(2) + '%"></span>';
        alleStufen.forEach(function (s, i) {
          var links = ((s.schwelle / maxSchwelle) * 100).toFixed(2);
          var gewaehltId = (zustand.eingeloest[s.schluessel] || {}).produkt || null;

          // Bild: das gewaehlte Geschenk, sonst das erste lieferbare
          var zeigeG = null;
          s.geschenke.forEach(function (g) { if (!zeigeG && gewaehltId && g.id === gewaehltId) zeigeG = g; });
          if (!zeigeG) {
            s.geschenke.forEach(function (g) {
              if (zeigeG) return;
              var b = bestand(g.handle);
              if (!b || b.verfuegbar) zeigeG = g;
            });
          }
          if (!zeigeG) zeigeG = s.geschenke[0] || null;

          var kl = frei[i] ? (gewaehltId ? 'is-erreicht' : 'is-offen') : 'is-zu';
          h += '<button type="button" class="lgl__bmark ' + kl + (offeneStufe === i ? ' is-auf' : '') + '" style="left:' + links + '%"'
            + ' data-lgl-auf="' + i + '"' + (frei[i] ? '' : ' disabled')
            + ' aria-expanded="' + (offeneStufe === i ? 'true' : 'false') + '"'
            + ' title="' + escape(zeigeG ? zeigeG.titel : geld(s.schwelle)) + '">';
          if (zeigeG) {
            var bq2 = bestand(zeigeG.handle);
            var src2 = (bq2 && bq2.bild) ? bq2.bild : zeigeG.bild;
            h += '<img src="' + escape(bildUrl(src2, 120)) + '" alt="" width="36" height="36"'
              + ' onerror="this.style.visibility=&quot;hidden&quot;">';
          } else {
            h += GESCHENK;
          }
          // Die Plakette sagt, was zu tun ist: + = einloesbar, Haken = schon
          // gewaehlt, Schloss = Stufe noch nicht erreicht. Ein blosser Haken
          // auf einer noch offenen Stufe hat wie "erledigt" ausgesehen.
          h += '<span class="lgl__badge">' + (frei[i] ? (gewaehltId ? HAKEN : PLUS) : SCHLOSS) + '</span>';
          h += '</button>';
          h += '<span class="lgl__schwelle" style="left:' + links + '%" aria-hidden="true">'
            + escape(geldKurz(s.schwelle)) + '</span>';
        });
        h += '</div>';

        // Aufgeklappte Stufe: Geschenke direkt waehlbar, ohne Popup und damit
        // ohne den Seiten-Reload, den die App beim Einloesen ausloest.
        if (offeneStufe !== null && alleStufen[offeneStufe] && frei[offeneStufe]) {
          var sO = alleStufen[offeneStufe];
          var gw = (zustand.eingeloest[sO.schluessel] || {}).produkt || null;
          h += '<div class="lgl__auf">';
          h += zeilenListe(sO, offeneStufe, true, gw);
          // Rueckfallebene: das Popup der App bleibt einen Klick entfernt.
          h += '<button type="button" class="lgl__mehr" data-lgl-popup="' + offeneStufe + '">'
            + escape(texte.waehlen) + '</button>';
          h += '</div>';
        }
        return h;
      }

      h += '<div class="lgl__track">';
      h += '<span class="lgl__fill" style="width:' + Math.min(100, (zustand.betrag / maxSchwelle) * 100).toFixed(2) + '%"></span>';
      alleStufen.forEach(function (s, i) {
        var kl = frei[i] ? (zustand.eingeloest[s.schluessel] ? 'is-erreicht' : 'is-offen') : 'is-zu';
        h += '<button type="button" class="lgl__mark ' + kl + '" style="left:' + ((s.schwelle / maxSchwelle) * 100).toFixed(2) + '%"'
          + ' data-lgl-popup="' + i + '"' + (frei[i] ? '' : ' disabled')
          + ' title="' + escape(geld(s.schwelle)) + '">'
          + (frei[i] ? (zustand.eingeloest[s.schluessel] ? HAKEN : PLUS) : GESCHENK) + '</button>';
        h += '<span class="lgl__schwelle" style="left:' + ((s.schwelle / maxSchwelle) * 100).toFixed(2) + '%"'
          + ' aria-hidden="true">' + escape(geldKurz(s.schwelle)) + '</span>';
      });
      h += '</div>';

      // Kacheln der gezeigten Stufe
      var stufe = alleStufen[zeigeIdx];
      var offen = frei[zeigeIdx];
      var gewaehlt = (zustand.eingeloest[stufe.schluessel] || {}).produkt || null;

      h += kachelListe(stufe, zeigeIdx, offen, gewaehlt);

      if (offen && texte.waehlen) {
        h += '<button type="button" class="lgl__btn" data-lgl-popup="' + zeigeIdx + '">' + escape(texte.waehlen) + '</button>';
      }
      return h;
    }

    function bildUrl(url, breite) {
      if (!url) return '';
      if (url.indexOf('width=') > -1) return url.replace(/width=\d+/, 'width=' + breite);
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + breite;
    }

    /* --- Kachelreihe einer Stufe (von A und vom Aufklappen in B genutzt) --- */
    function kachelListe(stufe, stufenIndex, offen, gewaehlt) {
      var lieferbar = [], vergriffen = [];
      stufe.geschenke.forEach(function (g) {
        var b = bestand(g.handle);
        if (b && !b.verfuegbar) vergriffen.push(g); else lieferbar.push(g);
      });
      // Ausverkauftes wird ausgeblendet - ausser es bliebe nichts uebrig.
      var liste = lieferbar.length ? lieferbar : vergriffen;
      var alleVergriffen = !lieferbar.length && vergriffen.length > 0;
      if (!liste.length) return '';

      var h = '<ul class="lgl__kacheln">';
      liste.forEach(function (g) {
        var istGewaehlt = gewaehlt === g.id;
        var kl = alleVergriffen ? 'is-vergriffen' : (istGewaehlt ? 'is-gewaehlt' : (offen ? 'is-waehlbar' : 'is-zu'));
        var klickbar = offen && !alleVergriffen;
        h += '<li class="lgl__kachel ' + kl + '"'
          + (klickbar ? ' data-lgl-geschenk="' + escape(g.id) + '" data-lgl-stufe="' + stufenIndex + '" role="button" tabindex="0"' : '')
          + ' title="' + escape(g.titel) + (alleVergriffen ? ' - ' + escape(texte.ausverkauft) : '') + '">';
        var bq = bestand(g.handle);
        var quelleBild = (bq && bq.bild) ? bq.bild : g.bild;
        h += '<span class="lgl__bild"><img src="' + escape(bildUrl(quelleBild, 160)) + '" alt="" width="58" height="58"'
          + ' onerror="this.style.visibility=&quot;hidden&quot;"></span>';
        if (istGewaehlt) h += '<span class="lgl__badge">' + HAKEN + '</span>';
        else if (!offen) h += '<span class="lgl__badge">' + SCHLOSS + '</span>';
        h += '</li>';
      });
      return h + '</ul>';
    }

    /* --- Aufgeklappte Stufe: schmale Produktzeilen -------------------------
       Aufbau bewusst uebernommen vom Cross-Selling-Block im Drawer
       (.lxs__zeile): Bild links, Titel und Preis in der Mitte, Aktion rechts.
       Der Kunde sieht damit, was er bekommt - Bild allein reichte nicht.
       Der Preis steht als Streichpreis daneben, "Kostenlos" in Gruen davor.
       ----------------------------------------------------------------------- */
    function zeilenListe(stufe, stufenIndex, offen, gewaehlt) {
      var lieferbar = [], vergriffen = [];
      stufe.geschenke.forEach(function (g) {
        var b = bestand(g.handle);
        if (b && !b.verfuegbar) vergriffen.push(g); else lieferbar.push(g);
      });
      var liste = lieferbar.length ? lieferbar : vergriffen;
      var alleVergriffen = !lieferbar.length && vergriffen.length > 0;
      if (!liste.length) return '';

      var h = '<ul class="lgg__liste">';
      liste.forEach(function (g) {
        var b = bestand(g.handle) || {};
        var istGewaehlt = gewaehlt === g.id;
        var kl = alleVergriffen ? 'is-vergriffen' : (istGewaehlt ? 'is-gewaehlt' : 'is-waehlbar');
        var klickbar = offen && !alleVergriffen;
        h += '<li class="lgg__zeile ' + kl + '"'
          + (klickbar ? ' data-lgl-geschenk="' + escape(g.id) + '" data-lgl-stufe="' + stufenIndex + '" role="button" tabindex="0"' : '')
          + '>';
        h += '<span class="lgg__bild"><img src="' + escape(bildUrl(b.bild || g.bild, 120)) + '" alt="" width="40" height="40"'
          + ' onerror="this.style.visibility=&quot;hidden&quot;"></span>';
        h += '<span class="lgg__txt">';
        h += '<span class="lgg__name">' + escape(b.titel || g.titel) + '</span>';
        h += '<span class="lgg__preis"><strong>' + escape(texte.kostenlos) + '</strong>';
        if (b.preis) h += '<span class="lgg__alt">' + escape(geld(b.preis)) + '</span>';
        if (alleVergriffen) h += '<span class="lgg__weg">' + escape(texte.ausverkauft) + '</span>';
        h += '</span></span>';
        h += '<span class="lgg__add" aria-hidden="true">' + (istGewaehlt ? HAKEN : PLUS) + '</span>';
        h += '</li>';
      });
      return h + '</ul>';
    }

    /* --- Welche Bestandsdaten braucht der naechste Aufbau wirklich? -------- */
    function benoetigteHandles(zustand) {
      if (!alleStufen) return [];
      var frei = alleStufen.map(function (s) { return istFrei(s, zustand); });
      if (variante === 'b') {
        // je Stufe das erste Geschenk - mehr zeigt B im eingeklappten
        // Zustand nicht an. Ist eine Stufe aufgeklappt, kommen deren
        // Geschenke dazu.
        var liste = alleStufen.map(function (s) { return s.geschenke[0] && s.geschenke[0].handle; });
        if (offeneStufe !== null && alleStufen[offeneStufe]) {
          alleStufen[offeneStufe].geschenke.forEach(function (g) { liste.push(g.handle); });
        }
        return liste.filter(Boolean);
      }
      var idx = -1;
      alleStufen.forEach(function (s, i) {
        if (idx === -1 && frei[i] && !zustand.eingeloest[s.schluessel]) idx = i;
      });
      if (idx === -1) { for (var i = 0; i < alleStufen.length; i++) { if (!frei[i]) { idx = i; break; } } }
      if (idx === -1) idx = alleStufen.length - 1;
      return (alleStufen[idx] ? alleStufen[idx].geschenke : []).map(function (g) { return g.handle; });
    }

    var zeichenTimer = null;
    function planeZeichnen() {
      clearTimeout(zeichenTimer);
      zeichenTimer = setTimeout(zeichne, 40);
    }

    /* --- Zeichnen ----------------------------------------------------------- */
    function zeichne() {
      try {
        if (!alleStufen || !alleStufen.length || !warenkorb) { zurueck(); return; }
        var zustand = warenkorbZustand(warenkorb);

        // Nur die Geschenke abfragen, die gleich auch gezeigt werden.
        // Vorher wurden pauschal alle acht geholt - gemessen 13 Requests auf
        // einem einzigen Seitenaufruf. Variante B braucht ein Bild je Stufe,
        // Variante A die Geschenke der gerade sichtbaren Stufe.
        benoetigteHandles(zustand).forEach(function (handle) {
          if (!bestand(handle)) holeBestand(handle, planeZeichnen);
        });

        var markup = baue(zustand);
        if (!markup) { zurueck(); return; }

        if (box.__markup !== markup) {
          box.__markup = markup;
          box.innerHTML = markup;
        }
      } catch (e) {
        zurueck();
      }
    }

    // Bekommt den Warenkorb von aussen gereicht - ein Abruf fuer alle
    // Instanzen statt einem je Instanz.
    function aktualisieren(c) {
      if (c) { warenkorb = c; zeichne(); return Promise.resolve(); }
      return ladeWarenkorb().then(function (x) { warenkorb = x; zeichne(); })
        .catch(function () { zurueck(); });
    }

    /* --- Bedienung ---------------------------------------------------------- */
    box.addEventListener('click', function (e) {
      var auf = e.target.closest ? e.target.closest('[data-lgl-auf]') : null;
      if (auf && !auf.disabled) {
        e.preventDefault();
        var idx = parseInt(auf.getAttribute('data-lgl-auf'), 10);
        offeneStufe = (offeneStufe === idx) ? null : idx;
        zeichne();
        return;
      }
      var pop = e.target.closest ? e.target.closest('[data-lgl-popup]') : null;
      var kachel = e.target.closest ? e.target.closest('[data-lgl-geschenk]') : null;
      if (kachel) {
        e.preventDefault();
        geschenkKlick(parseInt(kachel.getAttribute('data-lgl-stufe'), 10), kachel.getAttribute('data-lgl-geschenk'));
        return;
      }
      if (pop && !pop.disabled) {
        e.preventDefault();
        popupOeffnen(parseInt(pop.getAttribute('data-lgl-popup'), 10));
      }
    });

    box.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var ziel = e.target.closest ? e.target.closest('[role="button"][data-lgl-geschenk]') : null;
      if (!ziel) return;
      e.preventDefault();
      ziel.click();
    });

    // WICHTIG: hier KEIN window.addEventListener. Der Drawer wird bei jeder
    // Warenkorb-Aenderung per innerHTML ersetzt, also entsteht jedes Mal eine
    // neue Instanz. Haetten die je eigene Listener, blieben die alten am
    // Fenster haengen und jede davon wuerde weiter /cart.js abfragen -
    // gemessen: plus ein Request pro Drawer-Aktualisierung, unbegrenzt
    // wachsend. Die Registrierung passiert deshalb einmal zentral, siehe
    // unten bei planeAktualisierung().
    instanzen.push({ box: box, aktualisieren: aktualisieren, zeichne: zeichne });
    planeAktualisierung();
  }

  /* ------------------------------------------------------------------------
     Eine Registrierung fuer alle Instanzen. Ein Warenkorb-Abruf, ein
     Neuzeichnen - egal wie viele Leisten auf der Seite stehen (Produktseite
     und Drawer koennen gleichzeitig aktiv sein).
     ------------------------------------------------------------------------ */
  var planTimer = null;
  var laeuft = false;

  function planeAktualisierung() {
    clearTimeout(planTimer);
    planTimer = setTimeout(fuehreAus, 80);
  }

  function fuehreAus() {
    // Instanzen aufraeumen, deren Container nicht mehr im Dokument haengt
    instanzen = instanzen.filter(function (i) { return document.contains(i.box); });
    if (!instanzen.length || laeuft) return;
    laeuft = true;
    ladeWarenkorb()
      .then(function (c) {
        instanzen.forEach(function (i) { try { i.aktualisieren(c); } catch (e) { /* einzelne Instanz */ } });
      })
      .catch(function () { /* ohne Warenkorb kein Neuaufbau */ })
      .then(function () { laeuft = false; });
  }

  /* ------------------------------------------------------------------------
     Automatisches Popup der App unterbinden.

     Die App oeffnet ihr Geschenk-Popup selbst, sobald ein Artikel in den
     Warenkorb geht und dabei eine Stufe faellt (live reproduziert). Das kommt
     nicht von uns - in der Ereignis-Spur stand kein Meilenstein-Klick.
     Schliessen laesst es sich programmatisch nicht: weder Klick- noch
     Pointer-Ereignisse auf den Schliessen-Knopf greifen.

     Deshalb ist es im CSS grundsaetzlich verborgen und wird nur sichtbar,
     solange html die Klasse lgl-popup-an traegt. Umgedreht statt nachtraeglich
     ausblenden, weil Letzteres immer ein Zeitfenster laesst, in dem das dunkle
     Overlay aufblitzt.
     ------------------------------------------------------------------------ */
  var AN = 'lgl-popup-an';

  window.__lglPopupErlauben = function () {
    document.documentElement.classList.add(AN);
  };
  function popupVerbergen() {
    document.documentElement.classList.remove(AN);
  }

  // Sobald der Wrapper das Dokument verlaesst, gilt wieder: verborgen.
  try {
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var weg = ms[i].removedNodes;
        for (var j = 0; j < weg.length; j++) {
          var e = weg[j];
          if (e.nodeType !== 1) continue;
          if ((e.classList && e.classList.contains('vm-wrapper'))
            || (e.querySelector && e.querySelector('.vm-wrapper'))) popupVerbergen();
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) { /* ohne Beobachter bleibt das Popup nach dem Oeffnen sichtbar */ }

  // Eine Warenkorb-Aenderung ist genau der Moment, in dem die App von sich aus
  // aufmachen will - dann wieder zusperren.
  window.addEventListener('listCart', popupVerbergen);
  window.addEventListener('ajaxCart', popupVerbergen);

  function start() {
    var boxen = document.querySelectorAll('[data-lgl]:not([data-lgl-bereit])');
    for (var i = 0; i < boxen.length; i++) {
      boxen[i].setAttribute('data-lgl-bereit', '1');
      try { bediene(boxen[i]); } catch (e) { /* App-Leiste bleibt stehen */ }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  window.addEventListener('listCart', function () { start(); planeAktualisierung(); });
  window.addEventListener('ajaxCart', function () { start(); planeAktualisierung(); });
})();
